export default __webpack_public_path__ + "7856ed3.png";